import Application from "../../Application";
import Area, { IArea } from "../../core/areas/Area";
import { IRouter } from "../../runtime/Router";
import GetIndexHarmonizationReportInteractor from "../interactor/GetIndexHarmonizationReportInteractor";
import ShowIndexHarmonizationReportInteractor from "../interactor/ShowIndexHarmonizationReportInteractor";
import ShowIndexesByCategoryReportInteractor from "../interactor/ShowIndexesByCategoryReportInteractor";
import IndexHarmonizationReportPage from "../ui/pages/IndexHarmonizationReportPage";
import IndexesByCategoryDataPage from "../ui/pages/IndexesByCategoryDataPage";
import GetIndexesByCategoryIndexDataInteractor from "../interactor/GetIndexesByCategoryIndexDataInteractor";
import GetIndexNonHarmonizedReportInteractor from "../interactor/GetIndexNonHarmonizedReportInteractor";
import ShowIndexNonHarmonizedReportInteractor from "../interactor/ShowIndexNonHarmonizedReportInteractor";
import IndexNonHarmonizedReportPage from "../ui/pages/IndexNonHarmonizedReportPage";
import ShowOrganisationIndexByDateReportInteractor from "../interactor/ShowOrganisationIndexByDateReportInteractor";
import OrganisationIndexByDateReportPage from "../ui/pages/OrganisationIndexByDateReportPage";
import ShowCaseLawDocumentsByDateReportInteractor from "../interactor/ShowCaseLawDocumentsByDateReportInteractor";
import CaseLawDocumentsByDateReportPage from "../ui/pages/CaseLawDocumentsByDateReportPage";

export default class ReportArea extends Area implements IArea {
  private application: Application;
  private router: IRouter;

  constructor({
    application,
    router
  }: {
    application: Application;
    router: IRouter;
  }) {
    super();
    this.application = application;
    this.router = router;
  }
  private registerModules() {
    const container = this.application.container;
    container.registerInteractor(
      "showIndexHarmonizationReport",
      ShowIndexHarmonizationReportInteractor
    );
    container.registerInteractor(
      "showIndexNonHarmonizedReport",
      ShowIndexNonHarmonizedReportInteractor
    );
    container.registerInteractor(
      "getIndexHarmonizationReport",
      GetIndexHarmonizationReportInteractor
    );
    container.registerInteractor(
      "showIndexesByCategoryReport",
      ShowIndexesByCategoryReportInteractor
    );
    container.registerInteractor(
      "getIndexesByCategoryIndexData",
      GetIndexesByCategoryIndexDataInteractor
    );
    container.registerInteractor(
      "getIndexNonHarmonizedReport",
      GetIndexNonHarmonizedReportInteractor
    );
    container.registerInteractor(
      "showOrganisationIndexByDateReport",
      ShowOrganisationIndexByDateReportInteractor
    );
    container.registerInteractor(
      "showCaseLawDocumentsByDateReport",
      ShowCaseLawDocumentsByDateReportInteractor
    );
  }
  register(params: any) {
    this.registerModules();
    this.router.registerRoutes({
      path: "/index-harmonization-report",
      page: this.createPage({
        Page: IndexHarmonizationReportPage,
        action: this.showIndexHarmonizationReport.bind(this)
      }),
      options: {
        secure: true
      }
    });

    this.router.registerRoutes({
      path: "/index-non-harmonized-report",
      page: this.createPage({
        Page: IndexNonHarmonizedReportPage,
        action: this.showIndexNonHarmonizedReport.bind(this)
      }),
      options: {
        secure: true
      }
    });

    this.router.registerRoutes({
      path: "/indexes-by-category-data-report",
      page: this.createPage({
        Page: IndexesByCategoryDataPage,
        action: this.showIndexesByCategoryReport.bind(this)
      }),
      options: {
        secure: true
      }
    });

    this.router.registerRoutes({
      path: "/indexes-by-date-report",
      page: this.createPage({
        Page: OrganisationIndexByDateReportPage,
        action: this.showOrganisationIndexByDateReport.bind(this)
      }),
      options: {
        secure: true
      }
    });
    this.router.registerRoutes({
      path: "/case-law-documents-by-date-report",
      page: this.createPage({
        Page: CaseLawDocumentsByDateReportPage,
        action: this.showCaseLawDocumentsByDateReport.bind(this)
      }),
      options: {
        secure: true
      }
    });
  }

  public showIndexHarmonizationReport() {
    return this.application.container
      .resolve<ShowIndexHarmonizationReportInteractor>(
        "showIndexHarmonizationReport"
      )
      .execute();
  }
  public showIndexesByCategoryReport() {
    return this.application.container
      .resolve<ShowIndexesByCategoryReportInteractor>(
        "showIndexesByCategoryReport"
      )
      .execute();
  }
  public showIndexNonHarmonizedReport() {
    return this.application.container
      .resolve<ShowIndexNonHarmonizedReportInteractor>(
        "showIndexNonHarmonizedReport"
      )
      .execute();
  }
  public showOrganisationIndexByDateReport() {
    return this.application.container
      .resolve<ShowOrganisationIndexByDateReportInteractor>(
        "showOrganisationIndexByDateReport"
      )
      .execute();
  }
  public showCaseLawDocumentsByDateReport() {
    return this.application.container
      .resolve<ShowCaseLawDocumentsByDateReportInteractor>(
        "showCaseLawDocumentsByDateReport"
      )
      .execute();
  }
}
